/**
 * Whether the document is rendered inside the native React Native WebView shell.
 *
 * Lives outside the stores on purpose. `mainStore.isRN` is this same expression,
 * but reaching it means importing `~/stores`, and that barrel constructs every
 * store — several of which import the analytics barrel back. Before the routes
 * were split that cycle stayed inside one chunk and cost nothing; once each
 * route became its own chunk Rollup had to resolve the re-export across chunk
 * boundaries and warned that the initialisation order was no longer guaranteed.
 *
 * Anything that only needs the flag should use this rather than a store.
 */
export const isReactNativeWebView = (): boolean =>
  !import.meta.env.SSR && Boolean(window.ReactNativeWebView);
